// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/category_group.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { CategoryGroupService } from "./category_group_pb";

/**
 * ListCategoryGroups returns every group, by sort order then label.
 *
 * @generated from rpc travplaces.v1.CategoryGroupService.ListCategoryGroups
 */
export const listCategoryGroups = CategoryGroupService.method.listCategoryGroups;
